import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

type TeethLegendItemProps = {
    state: string;
    meaning: string;
};
const TeethLegendItem: FC<TeethLegendItemProps> = ({ state, meaning }: TeethLegendItemProps) => {
    return (
        <Box display="flex" alignItems="center" pr={2}>
            <Box
                sx={(theme) => ({
                    width: theme.spacing(4),
                    height: theme.spacing(4),
                    border: '1px solid black',
                    transform: 'scale(0.7)',
                })}
                className={`tState-${state}`}
            ></Box>
            <Typography variant="body1" align="center">
                {meaning}
            </Typography>
        </Box>
    );
};

const TeethLegend: FC = () => {
    const { t: translate } = useTranslation();

    return (
        <Box display="flex">
            <Box>
                <TeethLegendItem state="1" meaning={translate('orders:LEGEND_SELECTED')} />
            </Box>
            <Box>
                <TeethLegendItem state="2" meaning={translate('orders:LEGEND_PONTIC')} />
            </Box>
            <Box>
                <TeethLegendItem state="3" meaning={translate('orders:LEGEND_EXTRACTED')} />
            </Box>
            <Box>
                <TeethLegendItem state="4" meaning={translate('orders:LEGEND_MISSING')} />
            </Box>
        </Box>
    );
};

export default TeethLegend;
